import { Mic2, Guitar, Music4, Piano, Drum } from "lucide-react";
import Reveal from "./Reveal";

const MEMBERS = [
  { icon: Mic2, role: "Chant lead", name: "Catherine", desc: "Une voix exceptionnelle qui porte chaque refrain.", img: "/photos/chant-nb.webp", span: "sm:col-span-2 sm:row-span-2", pos: "object-[50%_35%]" },
  { icon: Guitar, role: "Guitare", name: "Stéphane", desc: "Riffs tranchants, solos enflammés.", img: "/photos/guitare.webp", span: "" },
  { icon: Music4, role: "Basse & chant", name: "Florence", desc: "Le groove qui fait bouger la foule.", img: "/photos/basse.webp", span: "" },
  { icon: Piano, role: "Claviers / Piano", name: "Thibault", desc: "Nappes, orgue et piano rock.", img: "/photos/claviers.webp", span: "", pos: "object-center" },
  { icon: Drum, role: "Batterie", name: "Florent", desc: "Une rythmique précise et puissante.", img: "/photos/batterie.webp", span: "", pos: "object-center" },
];

const Bio = () => (
  <section id="groupe" data-testid="band-bio-section" className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.25em] font-jbmono font-semibold text-amber-400 mb-4">
          Le groupe
        </p>
        <h2 className="font-display text-2xl sm:text-4xl font-bold tracking-tight uppercase mb-3">
          Cinq musiciens, <span className="text-amber-500">une énergie</span>
        </h2>
        <p className="text-zinc-400 max-w-2xl text-base mb-12">
          Forty One, c'est quatre musiciens — batterie, basse, guitare et piano —
          et une chanteuse à la voix exceptionnelle. Ensemble, ils reprennent les
          grands classiques du rock, des années 70 à nos jours, avec une exigence
          : que chaque concert soit une fête.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-3 gap-4 auto-rows-[190px]">
        {MEMBERS.map((m, i) => (
          <Reveal key={m.role} delay={i * 0.07} className={m.span}>
            <div
              data-testid={`member-card-${m.role.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="group relative h-full rounded-2xl overflow-hidden border border-zinc-800 hover:border-amber-500/40 transition-colors duration-500 bg-[#161622]"
            >
              {m.img && (
                <img
                  src={m.img}
                  alt={`Forty One — ${m.role}`}
                  loading="lazy"
                  className={`absolute inset-0 w-full h-full object-cover ${m.pos || "object-top"} opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-[opacity,transform] duration-700`}
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-[#09090D] via-[#09090D]/40 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <m.icon size={20} className="text-amber-500 mb-2" />
                <p className="font-display font-bold uppercase tracking-wide text-lg leading-tight">{m.role}</p>
                <p className="text-xs font-jbmono uppercase tracking-widest text-amber-400 mt-1">{m.name}</p>
                <p className="text-sm text-zinc-400 mt-1">{m.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}

        <Reveal delay={0.35} className="sm:col-span-2">
          <div
            data-testid="band-story-card"
            className="h-full rounded-2xl border border-amber-500/25 bg-gradient-to-br from-[#1E1E2E] to-[#161622] p-6 flex flex-col justify-center"
          >
            <p className="text-xs font-jbmono uppercase tracking-[0.25em] text-amber-400 mb-3">Notre ADN</p>
            <p className="text-base sm:text-lg leading-relaxed text-zinc-300">
              De Toto aux Cranberries, de Gossip à Jean-Jacques Goldman : un
              répertoire qui rassemble toutes les générations. Idéal pour les
              fêtes de village, festivals municipaux, 14 juillet et soirées
              estivales.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Bio;
